import { fetchData, apiURL } from './api_helper';

const addFavouriteLesson = data => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/favouriteLessons/${data.lessonId}/add`;
  fetchData(endpointURL, 'POST', [])
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

const removeFavouriteLesson = data => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/favouriteLessons/${data.lessonId}/remove`;
  fetchData(endpointURL, 'POST', [])
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

const listFavourites = page => new Promise((resolve, reject) => {
  const endpointURL = `${apiURL}/api/favouriteLessons/${page}`;
  fetchData(endpointURL, 'GET')
    .then((result) => {
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
});

export default {
  addFavouriteLesson,
  removeFavouriteLesson,
  listFavourites
};



// WEBPACK FOOTER //
// ./src/api/favourites.js